// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.bg-color[data-v-d20f0e44] {\n    background-color: #eff4f5;\n}\n", ""]);
// Exports
module.exports = exports;
